/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  UserFlagsModeratorControllerFindManyQueryResponse,
  UserFlagsModeratorControllerFindManyQueryParams,
  UserFlagsModeratorControllerFindMany401,
} from '../../types/UserFlagsModeratorControllerFindMany.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { userFlagsModeratorFindMany } from '../../methods/userFlagsModeratorFindMany.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const userFlagsModeratorFindManyQueryKey = (params?: UserFlagsModeratorControllerFindManyQueryParams) =>
  [{ url: '/api/moderator/user-flags' }, ...(params ? [params] : [])] as const;

export type UserFlagsModeratorFindManyQueryKey = ReturnType<typeof userFlagsModeratorFindManyQueryKey>;

export function userFlagsModeratorFindManyQueryOptions(
  params?: UserFlagsModeratorControllerFindManyQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = userFlagsModeratorFindManyQueryKey(params);
  return queryOptions<
    UserFlagsModeratorControllerFindManyQueryResponse,
    ResponseErrorConfig<UserFlagsModeratorControllerFindMany401>,
    UserFlagsModeratorControllerFindManyQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return userFlagsModeratorFindMany(params, config);
    },
  });
}

/**
 * {@link /api/moderator/user-flags}
 */
export function useUserFlagsModeratorFindMany<
  TData = UserFlagsModeratorControllerFindManyQueryResponse,
  TQueryData = UserFlagsModeratorControllerFindManyQueryResponse,
  TQueryKey extends QueryKey = UserFlagsModeratorFindManyQueryKey,
>(
  params?: UserFlagsModeratorControllerFindManyQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        UserFlagsModeratorControllerFindManyQueryResponse,
        ResponseErrorConfig<UserFlagsModeratorControllerFindMany401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? userFlagsModeratorFindManyQueryKey(params);

  const query = useQuery(
    {
      ...userFlagsModeratorFindManyQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<UserFlagsModeratorControllerFindMany401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
